import { Outlet } from "react-router-dom";
import { SiteHeader } from "@/components/layout/Header";
import { SiteFooter } from "@/components/layout/Footer";
import { MobileTabBar } from "@/components/layout/MobileTabBar";
import { WhatsAppFloatButton } from "@/components/layout/WhatsAppFloatButton";
import { CookieNotice } from "@/components/layout/CookieNotice";

/**
 * Layout boutique — équivalent SPA de apps/web/app/layout.tsx (root layout
 * Next.js : Header + Footer + MobileTabBar + WhatsAppFloatButton +
 * CookieNotice autour de `{children}`). `<html>`/`<body>` n'existent plus ici
 * (posés une seule fois dans index.html) ; `pb-16 lg:pb-0` dégage la barre
 * d'onglets basse fixe (mobile/tablette, §1.11), comme dans l'original.
 *
 * Les routes `/compte/**` et `/connexion` (cf. AccountLayout, imbriqué ICI en
 * route enfant) partagent ce chrome boutique — c'est déjà le comportement
 * d'apps/web aujourd'hui (pas de layout `(account)` dédié là-bas, donc le
 * layout racine s'applique tel quel à ces pages).
 */
export function ShopLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1 pb-16 lg:pb-0">
        <Outlet />
      </main>
      <SiteFooter />
      <MobileTabBar />
      <WhatsAppFloatButton />
      <CookieNotice />
    </div>
  );
}
